import { getCookie, setCookie } from '../common/utils/cookie';
import { store } from '../store';

const listenForSoftphoneStatus = () => {
  const { status } = store.getState().telephony;
  const softphoneStatus = getCookie('softphoneStatus');
  const softphoneOpen = getCookie('softphoneOpen');
  if ((softphoneOpen === 'true') && (status !== softphoneStatus)) {
    store.dispatch({ type: 'UPDATE_CALL_STATUS', status: softphoneStatus });
  }
};

export const sendSoftphoneStatus = (status) => {
  setCookie('softphoneStatus', status);
};

export function allowNav({ allowNavOnlyInCall, submitted, callStatus }) {
  // if meet type is 'inPerson' we do not want to disable nav
  // and nav should always be allowed.
  if (getCookie('meetType') === 'inPerson') return true;
  // if meet type is 'telephonicThreeWay' we do not want to disable nav
  // and nav should always be allowed.
  if (getCookie('meetType') === 'telephonicThreeWay') return true;

  // nav blocking only applies if theme.allowNavOnlyInCall is true
  // and the meetType is not 'inPerson'
  let allow = true;
  if (allowNavOnlyInCall && !submitted) {
    const softphoneStatus = getCookie('softphoneStatus');
    const softphoneOpen = getCookie('softphoneOpen');

    const statusCheckIntervalID = getCookie('statusCheckIntervalID');
    clearInterval(statusCheckIntervalID);
    const id = window.setInterval(listenForSoftphoneStatus, 1000);
    setCookie('statusCheckIntervalID', id);

    if (softphoneOpen === 'true' && softphoneStatus !== 'connected') {
      allow = false;
    } else if (callStatus !== 'connected') {
      allow = false;
    }
  }
  return allow;
}
